import { render, staticRenderFns } from "./DispatchersTotals.vue?vue&type=template&id=060ad73b"
import script from "./DispatchersTotals.vue?vue&type=script&lang=js"
export * from "./DispatchersTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports